/**
 * SessionNoteService
 * Server-synced per-viewer study notes on a CourseSession. Self-scoped: a caller
 * only ever reads/mutates their own single active note per session. Signed-in
 * users are attributed via their JWT; anonymous visitors pass an anonymousId.
 * Route base: api/session-notes
 */
import { BaseService } from '../base/BaseService';
export class SessionNoteService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SessionNoteService.DEFAULT_SERVICE_PATH,
            basePath: SessionNoteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** My own note for a session (null if I have none). Anonymous callers pass anonymousId. */
    async getMineForSession(sessionId, anonymousId) {
        const response = await this.getMineForSessionRaw(sessionId, anonymousId);
        return response.data ?? null;
    }
    getMineForSessionRaw(sessionId, anonymousId) {
        return this.http.get(this.buildUrlWithParams(`me/session/${sessionId}`, { anonymousId }));
    }
    /** Upsert my note for a session. Creates when absent, otherwise replaces the content. */
    async upsert(request) {
        const response = await this.upsertRaw(request);
        return response.data ?? null;
    }
    upsertRaw(request) {
        return this.http.post(this.buildUrl(''), request);
    }
    /** Soft-delete my own note for a session. Anonymous callers pass anonymousId. */
    async deleteMineForSession(sessionId, anonymousId) {
        const response = await this.deleteMineForSessionRaw(sessionId, anonymousId);
        return response.data ?? response.success;
    }
    deleteMineForSessionRaw(sessionId, anonymousId) {
        return this.http.delete(this.buildUrlWithParams(`me/session/${sessionId}`, { anonymousId }));
    }
}
SessionNoteService.DEFAULT_SERVICE_PATH = 'resources';
SessionNoteService.BASE_PATH = 'api/session-notes';
//# sourceMappingURL=SessionNoteService.js.map